<template>
	<div class="wrap">
		<DelData ref="delDatas"></DelData>
		<div class="navbar">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>组织生活</el-breadcrumb-item>
				<el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="datawrap">
			<div class="treeWrap" v-if="$store.state.user.userinfo.flag!=3">
				<tree @treeSelect="treeSelect"></tree>
			</div>
			<div class="datatable">
				<div class="datas">
					<div class="selectbar">
						<div>
							<el-input
								style="margin-right: 10px;width: 200px !important;" 
								size="small"
								v-model="getdata.name2" placeholder="输入被谈话人姓名"
								@input="getdata.page = 1;totalPage = 0;dataList();"
								clearable>
							</el-input>
							<el-select
								size="small"
								style="margin-right: 10px;width: 100px !important;" 
								v-model="getdata.year" placeholder="选择年份"
								@change="getdata.page = 1;totalPage = 0;dataList();"
								clearable>
								<el-option
									:key="index"
									v-for="(item,index) in $yearList()"
									:label="item"
									:value="item">
								</el-option>
							</el-select>
							<el-select
								size="small"
								style="width: 100px !important;" 
								v-model="getdata.month" placeholder="选择月份"
								@change="getdata.page = 1;totalPage = 0;dataList();"
								clearable>
								<el-option
									:key="index"
									v-for="(item,index) in $monthList()"
									:label="item+'月'"
									:value="item">
								</el-option>
							</el-select>
						</div>
						<div style="display: flex;align-items: center;">
							<el-button 
								style="margin-right:10px;"
								type="primary" size="small" @click="delAll">一键删除</el-button>
							<el-upload
								name="file"
								style="margin-right:10px;"
								:data="{
									dwid:this.$store.state.user.userinfo.dwid,
									token:$store.state.user.userinfo.token
								}"
								:action="$uploadFile"
								:show-file-list="false"
								multiple
								:limit="4"
								:on-success="success1"
								v-if="$store.state.user.userinfo.flag==1"
								:on-progress="uploadProcess"
								:before-upload="limitFiles">
								<el-button size="small" type="primary">文件上传</el-button>
							</el-upload>
							<el-button type="primary" size="small" @click="goAdd">新增</el-button>
						</div>
					</div>
					<div class="selectdata">
						<myTables 
							@selectEnable="selectEnable"
							:tableData="tableData"
							delkey="hyid"
							@selectList="selectList"
							:tableHeader="tableHeader"
							:loading="true" 
							:indexs="false"
							:selection="true">
						</myTables>
						<Page :totalPage="totalPage" :pageSize="10" @changedata="changedata"></Page>
						<div class="dwfile" v-if="dwFlies.files.length>0">
							<div class="filelabel">附件：</div>
							<div class="files">
								<div class="file" :key="index" v-for="(item,index) in dwFlies.files">
									<div>{{item.title}}</div>
									<i class="el-icon-close" 
									@click="delDwFiles(item.id)" 
									v-if="$store.state.user.userinfo.flag==1"></i>
									<i class="el-icon-download"
									 @click="zbDownloadFile(item.url)"
									 v-else></i>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import indexs from './mixins/index'
	export default{
		mixins: [indexs],
	}
</script>

<style lang="scss" scoped="scoped">
	.wrap{
		position: relative;
		height: 100%;
		width: 100%;
		.fengmian {
		    height: 86px;
		    width: 150px;
			object-fit: cover;
		}
		.switchBar{
			width: 100%;
			height: 40px;
			line-height: 40px;
			margin-bottom: 20px;
			border-bottom: 1px solid #DDDDDD;
			span{
				cursor: pointer;
				display: inline-block;
				line-height: 40px;
				font-size: 16px;
				margin-right: 20px;
				padding: 0 20px;
				font-weight: bold;
			}
			span:hover{
				color: #BB0000;
				border-bottom: 2px solid #bb0000;
			}
			.selectSwitch{
				color: #BB0000;
				border-bottom: 2px solid #bb0000;
			}
		}
	}
</style>

